import { useQueryClient } from "@tanstack/react-query";

import {
    getGetUsersUserIdOauthConnectionsQueryKey,
    useDeleteUsersUserIdOauthConnectionsClientId,
} from "api/generated/users/users";

export function useRevokeOAuthConnectionMutation() {
    const client = useQueryClient();

    return useDeleteUsersUserIdOauthConnectionsClientId({
        mutation: {
            onSuccess: (_response, { userId }) => {
                client.invalidateQueries({
                    queryKey: getGetUsersUserIdOauthConnectionsQueryKey(userId),
                });
            },
        },
    });
}
